import React, { useRef, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useSelector } from 'react-redux';
import {
  StyledFormControl,
} from 'apps/web_forms/components/Form/styles';
import FormPageHeader from 'apps/web_forms/components/FormPageHeader';
import FormElements from 'apps/web_forms/components/Form/FormElements';
import DMButton from 'apps/web_forms/components/commons/DMButton';

const Submission = ({ goBackUrl, selectedForm = {}, loading, form, submit, showNotificationBar, submissionId }) => {
  const formContext = useFormContext();
  const dispatchAnswers = useSelector((state) => state.form.dispatchAnswers);
  const isSubmitting = useSelector((state) => state.form.isSubmitting);
  const isRenderedOnce = useRef(false);

  useEffect(() => {
    if (Object.keys(dispatchAnswers).length > 0 && !isRenderedOnce) {
      for (const [key, value] of Object.entries(dispatchAnswers)) {
        register(key);
        setValue(key, value);
      }
      isRenderedOnce.current = true;
    }
  }, [dispatchAnswers]);

  const returnToWebStore = () => {
    window.location.replace(goBackUrl);
  };


  return !loading && (
    <React.Fragment>
      <FormPageHeader
          sticky
          notificationBarShowing={showNotificationBar}
          title={selectedForm.title}
          submissionId={submissionId}
          description={selectedForm.description}
          goBackUrl={goBackUrl}
          isSubmitting={isSubmitting}
          renderToggleButton={false}
          renderRightButton={() => (
            <DMButton
              disabled={isSubmitting}
              filled
              type='submit'
            >
              {'Save'}
            </DMButton>
          )}
          renderSecondaryRightButton={
            () => (
                <DMButton
                  disabled={isSubmitting}
                  callbackMethod={() => returnToWebStore()}
                >
                  {'Cancel'}
                </DMButton>
              )
          }
        />
        <StyledFormControl>
          <FormElements
            elements={form.inputList || []}
            getInput={form.getInput}
            dispatchInitialAnswers={form.dispatchInitialAnswers}
            formContext={formContext}
            formErrors={formContext.errors}
          />
        </StyledFormControl>
    </React.Fragment>
  );
};

export default Submission;